// Shared RFC/RFIC renderer for the admin ViewLesson preview.
// Looks for reasoning in: TD_Rsn_* elements, then KSD_MW_Info parts.
export const renderRfcRfic = (
  iframeDoc: Document,
  correctIds?: string[]   // option ids that count as "correct" (for TD_Rsn_ types)
): boolean => {
  if (!iframeDoc || iframeDoc.getElementById('el-explanation-container')) return true;

  let rfcHtml = '';
  let rficHtml = '';
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

  // 1) Per-option reasoning
  const rsn = Array.from(iframeDoc.querySelectorAll('[id^="TD_Rsn_"]')) as HTMLElement[];
  if (rsn.length > 0) {
    rsn.forEach((el, i) => {
      const html = el.innerHTML.trim();
      if (!html) return;
      const id = el.id.replace('TD_Rsn_', '');
      const block = `<i>Option ${letters[i]}</i><br>${html}<br><br>`;
      if (!correctIds || correctIds.includes(id)) rfcHtml += block;
      else rficHtml += block;
    });
  }

  // 2) Question-level explanations in KSD_MW_Info
  if (!rfcHtml && !rficHtml) {
    const info = iframeDoc.getElementById('KSD_MW_Info') as HTMLInputElement | null;
    const parts = info?.value ? info.value.split('|') : [];
    if (parts.length > 15) {
      rfcHtml = (parts[14] || '').trim();
      rficHtml = (parts[15] || '').trim();
    } else if (parts.length > 0) {
      const last = (parts[parts.length - 1] || '').trim();
      if (last && last !== '0N<NEW LINE>') rfcHtml = last;
    }
  }

  if (!rfcHtml && !rficHtml) return false;

  const container = iframeDoc.createElement('div');
  container.id = 'el-explanation-container';
  container.innerHTML = `
    <hr style='height:1px; background-color:#cfcfcf; border:none; margin:50px 30px 30px;'>
    <p style='font-size:24px; color:#797979; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding:0 30px; margin:0 0 20px'>Explanation</p>
    <p style='font-size:24px; color:#000000; font-family:Arial,Helvetica,sans-serif; line-height:30px; padding:0 30px; margin:0 0 50px'>
      ${rfcHtml ? `<span style="font-weight:bold">RFC</span><br>${rfcHtml}` : ''}
      ${rficHtml ? `<br><span style="font-weight:bold">RFIC</span><br>${rficHtml}` : ''}
    </p>`;
  iframeDoc.body.appendChild(container);
  setTimeout(() => { iframeDoc.documentElement.scrollTop = iframeDoc.documentElement.scrollHeight; }, 100);
  return true;
};